<template>
  <div class="backyanse">
    <MyHelloWorld :numer="number"></MyHelloWorld>
    <!-- 右边图标 -->
    <Righticon></Righticon>
    <el-row>
      <el-col :span="24">
        <el-container class="conta auto">
          <el-image class="img" :src="$t('menu.TestApplicationFormImg')" alt=""></el-image>
        </el-container>
      </el-col>
    </el-row>
    <div class="content">
      <el-row>
        <el-col :span="7">
          <Content>
            <template #MingChen>
              <div>{{ $t("menu.customer") }}</div>
            </template>

            <template #ContentEr>
              <div class="inlineer">
              <li>          <router-link to="/CustomerInspection">
                    <div>{{ $t("menu.Instructions") }}</div></router-link>
                  </li> 
              </div>
            </template>

            <template #ContentSan>
              <div class="inlineer">
               <li><router-link to="/TestApplicationForm">
                  <div style="color: #1d2088">{{ $t("menu.Testapplicationform") }}</div></router-link></li> 
              </div>
            </template>
            <template #ContentSi>
              <div class="inlineer">
              <li><div>  <router-link to="/TheReportQuery">{{ $t("menu.TheReportQuery") }}</router-link></div></li>
              </div>
            </template>
            <template #ContentWu>
              <div class="inlineer">
                <li> <router-link to="/TheInspectionProcess"><div>{{ $t("menu.TheInspectionProcess") }}</div></router-link></li>
              </div>
            </template>
          </Content>
        </el-col>
        <el-col :span="17">
          <div class="inline">
            <el-divider direction="vertical"></el-divider>
            <h3 class="Xjiao">{{ $t("menu.Testapplicationform") }}</h3>
          </div>
          <div class="fff">
   
             <el-row :gutter="10"  v-for="(item,index) in SelectList" :key="index"> 
                <el-col :span="12">
                  <div class="Table">
                      <el-image class="JianCheColor" :src="ImgeJianCheColor" alt=""></el-image>
                        <div class="RightJianCe">
                          <div class="end">
                                 <h4 >{{item.fileName}}</h4>
                                <el-button size="mini" class="details"   @click="SelectOpen(item)"  round   style=" width: 59%;">{{ $t("menu.download") }} 
                                      <i class="el-icon-download"></i>
                                </el-button >
                              </div>
                        </div>
                  </div>
                   
          
                </el-col>
      
             </el-row>
          </div> 
        </el-col>
      </el-row>
    </div>
    <!-- 底部 -->
    <MyFooter> </MyFooter>
  </div>
</template>

  
<style lang="less" scoped>
.Table{
  display: flex;
  height: 230px;
  align-items: end;
  // margin-right: 10px;
  margin-bottom: 10px;
}
.end{
     margin-top: 100px;
}
 .JianCheColor{

  height: 230px;
  width: 200px;

}
.details{
color: #1D2088;
margin: 0px;
}
.details:hover,.details:focus{
  color: #eeeeee;
}

 .RightJianCe{
  // display: flex;
  // align-items: flex-end;
  padding:0px 15px;
  width: 160px;
height: 188px;
background: #F2F2F2;
position: relative;
bottom: 0px;
}
.White {
  position: relative;
  top: 69px;
  height: 60px;
  width: 280px;
  background: #999999;
}
.conta {
  margin-top: 161px;
}
.SanJiao {
  position: relative;
  bottom: 40px;
  left: 228px;
}

.shisi {
  font-size: 14px;
  background: #ffffff;
  padding: 10px;
  padding-left: 20px;
}
.Xjiao {
  color: #1d2088;
  font-size: 20px;
}

.divider {
  background-color: #eeeeee;
}
.fff {
  background: #ffffff;
  padding: 20px;
  margin-bottom: 20px;
  padding-top: 0px;
  /* height: auto; */
}

a:-webkit-any-link {
  color: -webkit-link;
  cursor: pointer;
  text-decoration: none;
  color: black;
}
a:-webkit-any-link:focus,
a:-webkit-any-link:hover {
  color: #1d2088;
}
span {
  font-size: 14px;
  padding: 16px;
display: inline-block;
  color: #666666;
}
</style>

<script>
export default {
  name: "TestApplicationForm",

  data() {
    return {
      number: "5-2",

      SelectList:[],
      title:'',
      ImgeJianCheColor:  require("@/assets/images/about/FenMian.jpg"),
    };
  }, 
   created: function () {
    if (this.$i18n.locale == "TC") {
      this.title = "TC";
    } else if (this.$i18n.locale == "EN") {
      this.title = "EN";
    } else if (this.$i18n.locale == "SC") {
      this.title = "SC";
    }
    this.getSelect();
  },
  methods: {
     async getSelect() {
      //橡胶
      const { data: resER } = await this.$http.get("/Service/GetApplication", {
        params: { languageType: this.title }
      });

      if (resER.code !== 200) return console.log("数据请求失败! ");
      // 文字
  this.SelectList = resER.data;
      console.log(this.SelectList);
  

    },

    SelectOpen(fd){
      window.open(fd.fileUrl)
      // +'?attname=fd.fileName'
    }
  },
};
</script>